import { createContext, Dispatch, SetStateAction } from 'react';

// 1. Define the shape of the context data
export interface ClientDashboardContextInterface {
    clientName: string;
    clientData: any; // Replace 'any' with your specific Client interface if available
    clientId: string | number;
    dfsClientId: string;
    appsPageNumber: number;
    setAppsPageNumber: Dispatch<SetStateAction<number>>;
    containerPageNumber: number;
    setContainerPageNumber: Dispatch<SetStateAction<number>>;
}

// 2. Initialize the context.
// We initialize with 'undefined' and type it to allow the interface OR undefined.
// This forces us to handle the case where a component tries to use the context
// without being wrapped in a Provider.
const ClientDashboardContext = createContext<ClientDashboardContextInterface | undefined>(undefined);

export default ClientDashboardContext;
